import React from "react";

import { viewEyeGray } from "../../../../assets/images";
import type { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { formateDateTime } from "../../../../utils/commonFunctions";
import UpdatedByAndUpdatedAt from "../../../commons/CommonUpdatedByAndUpdatedAt";

type AppProps = {
  data: any[];
  tableHeader: TableHeadersType[];
  type: string;
  handleBOMSavedTemplateView?: (data: any) => void;
};
const BOMSavedTemplateTableData = ({
  data,
  type,
  tableHeader,
  handleBOMSavedTemplateView,
}: AppProps) => {
  return (
    <>
      {data?.map((item: any) => {
        return (
          <tr>
            {tableHeader?.map((header: TableHeadersType) => {
              if (header?.value === "template_name") {
                return (
                  <td>{item?.template_name ? item?.template_name : "NA"}</td>
                );
              } else if (header?.value === "template_id") {
                return <td>{item?.template_id ? item?.template_id : "NA"}</td>;
              } else if (header?.value === "primary_item_name") {
                return (
                  <td>
                    {item?.primary_item_name ? item?.primary_item_name : "NA"}
                  </td>
                );
              } else if (header?.value === "branch_name") {
                return <td>{item?.branch_name ? item?.branch_name : "NA"}</td>;
              } else if (header?.value === "created_by") {
                return (
                  <td>
                    <UpdatedByAndUpdatedAt
                      firstName={item?.updated_by?.first_name}
                      lastName={item?.updated_by?.last_name}
                      profilePic={item?.updated_by?.profile_pic?.file_url}
                      updatedAt={formateDateTime(item?.updated_at)}
                    />
                  </td>
                );
              } else if (header?.value === "Action") {
                return (
                  <td>
                    {type?.length > 0 ? (
                      <span
                        onClick={() =>
                          handleBOMSavedTemplateView?.({
                            data: item,
                            name: "Use This Template",
                          })
                        }
                        className="pointer"
                        style={{ color: "#dd4433", fontSize: "14px" }}
                      >
                        Use This Template
                      </span>
                    ) : (
                      <span
                        className="pointer"
                        onClick={() =>
                          handleBOMSavedTemplateView?.({
                            data: item,
                            name: "",
                          })
                        }
                      >
                        <img
                          src={viewEyeGray}
                          alt="eye"
                        />
                      </span>
                    )}
                  </td>
                );
              } else {
                return <td>NA</td>;
              }
            })}
          </tr>
        );
      })}
    </>
  );
};

export default BOMSavedTemplateTableData;
